

<template>
	<div id="CookiesInfo">
        <div id="CookiesInfo_close" class="fullPageStatic_close" style="width: 24px; height: 24px;" v-on:click="close"></div>
We use cookies to customize content for your viewing and for analytics. If you continue to browse this website, we will assume that you are happy to receive all our cookies. For further information please read our cookie policy.
	</div>
</template>

<script>
export default {
	name: 'CookiesInfo',
	props: {
		App: Object
	},
	data : function() {
		return {
			
		}
	},
	mounted() {
		
	},
	created() {
	},
	methods : {
        close() {
            this.App.cookiesPopupDisplay = false;
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
